import React from 'react';
import { useDispatch, useSelector } from 'react-redux'

import { ERROR } from 'pu-data/QuoteSteps';
import Error from 'shared/product_tabs/tab_assembly/components/Error';
import { selectAssemblyDataForMatrix } from 'shared/product_tabs/tab_assembly/selector/selector';
import USPrices from 'shared/product_tabs/tab_assembly/components/price/us/Prices';
import MXPrices from 'shared/product_tabs/tab_assembly/components/price/mx/Prices';
import assemblyVariants from 'shared/product_tabs/tab_assembly/data/assemblyVariants';

import {
  doEmailQuote,
  setPriceSelected,
} from '../assemblySlice';

const Prices = () => {
  const dispatch = useDispatch();
  const {
    parameters,
    quote,
    quoteStep,
    parametersChanged,
    suppliers,
  } = useSelector(selectAssemblyDataForMatrix);

  const onPriceSelect = (data) => {
    data['currentVariant'] = assemblyVariants[data['supplier']];
    dispatch(setPriceSelected(data))
  }
  const onSendEmailQuote = (data, token) => dispatch(doEmailQuote({ data, token }));

  const props = {
    parameters,
    quote,
    quoteStep,
    parametersChanged,
    suppliers,
    onPriceSelect,
    onSendEmailQuote,
  }

  return (
    <div className="pcb-price-section">
      {quoteStep === ERROR ? (
        <Error />
      ) : (
        <>
          <USPrices {...props} />
          <MXPrices {...props} />
        </>
      )}

    </div>
  )
}

export default Prices;
